import React, {useEffect} from "react";
import {StyledEntrantInfo} from "./index.styles";
import {Button, Col, Row, Table} from "antd";
import {MyButton, MyText} from "../../../components";
import {useDispatch, useSelector} from "react-redux";
import {selectStore} from "../../../store/selector";
import {fetchEntrantInfoAction} from "../../../store/pages/admission/actions";
import {useNavigate} from "react-router-dom";

export const EntrantInfo = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {admission: {entrantInfo}} = useSelector(selectStore)

  useEffect(() => {
    dispatch(fetchEntrantInfoAction())
  }, []);

  // const columns = [
  //   {
  //     title: 'Name',
  //     dataIndex: 'name',
  //     key: 'name',
  //   },
  //   {
  //     title: 'Age',
  //     dataIndex: 'age',
  //     key: 'age',
  //   },
  //   {
  //     title: 'Address',
  //     dataIndex: 'address',
  //     key: 'address',
  //   },
  // ];

  const columns = [
    {
      title: "Имя абитуриента",
      key: "name_entrant",
      dataIndex: "name_entrant",
    },
    {
      title: "Фамилия абитуриента",
      key: "surname_entrant",
      dataIndex: "surname_entrant",
    },
    {
      title: "Рейтинг ранжирования",
      key: "contest_rating",
      dataIndex: "contest_rating",
    },
    {
      title: "Средний рейтинг аттестата",
      key: "average_rating",
      dataIndex: "average_rating",
    },
    {
      title: "Квалификация",
      render: (index:any, record:any, text:any) => {
        return (
          <div key={`${record.name_entrant}-${record.qualification && record.qualification.code}-${index} `}>
            <MyText weight={700} size={14}>{record.qualification && record.qualification.code}</MyText>
            <MyText size={14}>-{record.qualification && record.qualification.caption}</MyText>
          </div>
        )
      }
    },
    {
      title: "Специальность",
      render: (index:any, record:any, text:any) => {
        return (
          <div key={`${record.name_entrant}-${record.speciality && record.speciality.code}-${index} `}>
            <MyText weight={700} size={14}>{record.speciality && record.speciality.code}</MyText>
            <MyText size={14}>-{record.speciality && record.speciality.caption}</MyText>
          </div>
        )
      }
    },
    {
      title: "Колледж",
      render: (index:any, record:any, text:any) => {
        return (
          <div key={`${record.name_entrant}-${record.college && record.college.name}-${index} `}>
            <MyText size={14}>{record.college && record.college.name}</MyText>
          </div>
        )
      }
    },
  ]


  return(
    <StyledEntrantInfo>
      <Row justify="center" style={{marginBottom: 32}}>
        <Col span={1}>
          <MyButton type="default" onClick={() => navigate('/auth')} style={{background: "#fff"}}>Назад</MyButton>
        </Col>
        <Col span={23} style={{textAlign: "center"}}>
          <h1>Информация для абитуриентов</h1>
        </Col>
      </Row>

      <Row justify="space-between">
        <Col span={24}>
          <div className="style-card">
            <div className="style-card__header">
              <MyText weight={500} size={20} lineHeight="32px">Списочный состав абитуриентов, участвующих в конкурсе</MyText>
            </div>
            <div className="style-card__body">
              <Table bordered dataSource={[]} loading={entrantInfo.loading} scroll={{y: 560}} columns={columns}/>
            </div>
          </div>
        </Col>
        {/*<Col>*/}
        {/*  news?/*/}
        {/*</Col>*/}
      </Row>
    </StyledEntrantInfo>
  )
}